import { z } from "zod";
export const SourceRepoKind = z.enum(["git", "local"]);
export const SourceRepoCategory = z.enum([
    "service",
    "library",
    "frontend",
    "infra",
    "unknown",
]);
export const SourceRepoAuthMethod = z.enum(["none", "pat"]);
export const SourceRepoStatus = z.enum([
    "pending",
    "cloning",
    "analyzing",
    "generating",
    "indexing",
    "indexed",
    "error",
]);
export const SourceRepoSummary = z.object({
    id: z.string().uuid(),
    name: z.string(),
    kind: SourceRepoKind,
    category: SourceRepoCategory,
    teamId: z.string().uuid().nullable(),
    teamName: z.string().nullable(),
    url: z.string(),
    authMethod: SourceRepoAuthMethod,
    defaultBranch: z.string().nullable(),
    lastSyncStartedAt: z.string().datetime().nullable(),
    lastSyncedAt: z.string().datetime().nullable(),
    lastSyncedSha: z.string().nullable(),
    status: SourceRepoStatus,
    statusMessage: z.string().nullable(),
    tags: z.array(z.string()),
    customPrompt: z.string().nullable(),
    readmePrompt: z.string().nullable(),
    readmePromptSource: z.string().nullable(),
    excludeFromDefault: z.boolean(),
    specCount: z.number().int().nonnegative(),
    createdAt: z.string().datetime(),
});
export const SourceRepoListResponse = z.object({
    repos: z.array(SourceRepoSummary),
});
export const SourceRepoCreateRequest = z
    .object({
    kind: SourceRepoKind.default("git"),
    // For kind=git: an https:// URL. For kind=local: an absolute filesystem path.
    url: z.string().min(1),
    name: z.string().min(1).max(200).optional(),
    authMethod: SourceRepoAuthMethod.default("none"),
    authCredential: z.string().min(1).optional(),
})
    .refine((v) => v.kind !== "git" ||
    (/^https:\/\//.test(v.url) &&
        z.string().url().safeParse(v.url).success), {
    message: "Git source requires an https:// URL. (SSH support is on the roadmap.)",
    path: ["url"],
})
    .refine((v) => v.kind !== "local" || v.url.startsWith("/"), {
    message: "Local source requires an absolute filesystem path (starts with '/').",
    path: ["url"],
})
    .refine((v) => v.kind !== "local" || v.authMethod === "none", {
    message: "Local source does not use authentication; set authMethod to 'none'.",
    path: ["authMethod"],
})
    .refine((v) => v.authMethod !== "pat" || (v.authCredential ?? "").length > 0, {
    message: "authCredential is required when authMethod is 'pat'",
    path: ["authCredential"],
});
export const SourceRepoIdParam = z.object({
    id: z.string().uuid(),
});
export const SourceRepoUpdateRequest = z.object({
    tags: z.array(z.string().min(1)).optional(),
    customPrompt: z.string().max(8000).nullable().optional(),
    excludeFromDefault: z.boolean().optional(),
    category: SourceRepoCategory.optional(),
    /** `null` clears the team assignment. */
    teamId: z.string().uuid().nullable().optional(),
});
export const SourceRepoSyncResponse = z.object({
    enqueued: z.literal(true),
});
export const SourceRepoDeleteResponse = z.object({
    deleted: z.literal(true),
});
export const RepoSpecDetail = z.object({
    id: z.string().uuid(),
    domain: z.string(),
    title: z.string(),
    filePath: z.string(),
    content: z.string(),
    generatedAt: z.string().datetime(),
});
export const RepoSpecsListResponse = z.object({
    specs: z.array(RepoSpecDetail),
});
//# sourceMappingURL=repos.js.map